export const fileUpload = {
    slots: {
        base: 'p-4 rounded-lg border-neutral-400',
        wrapper: 'flex-row items-start text-left gap-4',
        label: 'mt-0',
        fileLeadingAvatar: 'p-2 rounded-lg border border-neutral-200 bg-white',
        fileName: 'text-sm font-semibold',
        fileSize: 'text-muted',
        fileTrailingButton: 'text-red-dark',
    },
    variants: {
        variant: {
            area: {
                wrapper: 'p-0',
            },
        },
        layout: {
            list: {
                file: 'border-neutral-600',
            },
        },
        size: {
            md: {
                file: 'p-3 gap-3',
            },
        },
    },
}
